// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right[data-v-8c99112c]{text-align:right}.detail[data-v-8c99112c]{color:#666;font-size:.8em}.per[data-v-8c99112c]{font-style:italic;text-align:center;width:100%;display:block}.spacer[data-v-8c99112c]{height:24px}.spacer *[data-v-8c99112c]{position:relative;top:50%}.swatch[data-v-8c99112c]{width:12px;height:12px;content:\" \";display:block;background:#00f}", ""]);
// Exports
module.exports = exports;
